var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 120,
    viewBox: "0 0 193 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4258 117.616V51.2755L79.9799 22.2516L170.6 49.2023V117.616",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.8835 117.27H57.5V111.051H63.7258V104.831H69.2599V99.303H75.4857V93.7746H81.0197V87.5552H87.2455V82.7179H88.629V88.9373H82.4032V95.1567H76.8692V100.685H70.6434V106.213H65.1093V112.433H58.8835V117.27Z",
    fill: "#302322"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193 115.543H172.676V47.6542L79.7803 20.0262L20.3515 49.9969V115.543H0V119.689H193V115.543ZM168.526 115.543H24.502V84.791H168.526V115.543ZM168.526 80.6447H24.502V52.5537L80.1815 24.4766L168.526 50.7501V80.6447Z",
    fill: "#302322"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3321 0C29.3223 0 0.932617 28.3536 0.932617 63.3343C0.932617 87.9701 14.8438 108.84 35.4028 119.309H49.238H61.6896H75.5247H87.9763H91.4351C113.433 109.372 127.725 89.0205 127.725 63.3343C127.732 28.3536 99.3419 0 64.3321 0Z",
    fill: "url(#paint0_radial_2008_28844)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3314 76.5126C71.6171 76.5126 77.5232 70.6125 77.5232 63.3344C77.5232 56.0562 71.6171 50.1561 64.3314 50.1561C57.0458 50.1561 51.1396 56.0562 51.1396 63.3344C51.1396 70.6125 57.0458 76.5126 64.3314 76.5126Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2015 65.1314C58.994 65.1314 58.7795 65.0415 58.6342 64.8688C58.3783 64.5578 58.4198 64.0948 58.7311 63.8391C61.9893 61.1233 66.7278 61.1233 69.986 63.8391C70.2973 64.0948 70.3388 64.5578 70.0828 64.8688C69.8199 65.1797 69.3634 65.2212 69.0521 64.9655C66.3335 62.7058 62.3905 62.7058 59.6719 64.9655C59.5335 65.0761 59.3675 65.1314 59.2015 65.1314Z",
    fill: "#497692"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0895 62.5328C71.9165 62.5328 71.7436 62.4706 71.6052 62.3531C67.4616 58.7044 61.2081 58.7044 57.0645 62.3531C56.7601 62.6226 56.2967 62.595 56.0269 62.2909C55.7571 61.9869 55.7917 61.5239 56.0891 61.2544C60.7862 57.1219 67.8698 57.1219 72.5668 61.2544C72.8711 61.5239 72.8988 61.9869 72.629 62.2909C72.4907 62.4499 72.2901 62.5328 72.0895 62.5328Z",
    fill: "#497692"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8901 67.7389C66.7449 67.7389 66.5927 67.6974 66.4682 67.6005C65.2022 66.7012 63.4936 66.7012 62.2208 67.6005C61.8887 67.8357 61.4322 67.7596 61.197 67.4276C60.9618 67.0955 61.0379 66.639 61.3699 66.4038C63.1477 65.1379 65.5343 65.1379 67.3121 66.4038C67.6441 66.639 67.7202 67.0955 67.485 67.4276C67.3398 67.6282 67.1184 67.7389 66.8901 67.7389Z",
    fill: "#497692"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6448 70.833C64.5411 70.833 64.4443 70.8122 64.3613 70.7777C64.2715 70.7431 64.1954 70.6878 64.1263 70.6256C64.0572 70.5495 64.0019 70.4735 63.9673 70.3836C63.9328 70.2938 63.9189 70.2039 63.9189 70.1071C63.9189 70.0104 63.9328 69.9136 63.9673 69.8306C64.0019 69.7339 64.0641 69.6578 64.1263 69.5887C64.1954 69.5196 64.2715 69.4712 64.3613 69.4366C64.6309 69.3191 64.9558 69.3882 65.1563 69.5887C65.2254 69.6578 65.2807 69.7339 65.3153 69.8306C65.3498 69.9205 65.3637 70.0104 65.3637 70.1071C65.3637 70.2039 65.3498 70.3007 65.3153 70.3836C65.2807 70.4735 65.2254 70.5495 65.1563 70.6256C65.018 70.7638 64.8383 70.833 64.6448 70.833Z",
    fill: "#497692"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6138 119.309H188.979C193.061 110.941 192.307 110.243 192.307 100.305C192.307 65.3317 163.924 36.9712 128.907 36.9712C93.8975 36.9712 65.5078 65.3248 65.5078 100.305C65.5147 108.66 65.6669 111.998 68.6138 119.309Z",
    fill: "url(#paint1_radial_2008_28844)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.832 120V101.653L140.554 101.687",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.74 95.4676V105.142C142.74 108.197 140.263 110.671 137.206 110.671H121.987C118.93 110.671 116.453 108.197 116.453 105.142V95.4676C116.453 92.4132 118.93 89.9392 121.987 89.9392H137.206C140.263 89.9392 142.74 92.4132 142.74 95.4676Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.475 81.5922C124.267 81.5922 124.053 81.5023 123.908 81.3296C123.652 81.0186 123.693 80.5556 124.005 80.2999C127.263 77.5841 132.001 77.5841 135.259 80.2999C135.571 80.5556 135.612 81.0186 135.356 81.3296C135.093 81.6405 134.637 81.682 134.326 81.4263C131.607 79.1666 127.664 79.1666 124.945 81.4263C124.807 81.5369 124.641 81.5922 124.475 81.5922Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.354 78.9937C137.181 78.9937 137.008 78.9315 136.87 78.8141C132.726 75.1654 126.473 75.1654 122.329 78.8141C122.025 79.0836 121.561 79.0559 121.292 78.7519C121.022 78.4478 121.056 77.9848 121.354 77.7153C126.051 73.5829 133.134 73.5829 137.831 77.7153C138.136 77.9848 138.163 78.4478 137.894 78.7519C137.762 78.9108 137.562 78.9937 137.354 78.9937Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.155 84.1996C132.01 84.1996 131.857 84.1581 131.733 84.0612C130.467 83.1619 128.758 83.1619 127.485 84.0612C127.153 84.2964 126.697 84.2203 126.462 83.8883C126.226 83.5562 126.303 83.0997 126.635 82.8645C128.412 81.5986 130.799 81.5986 132.577 82.8645C132.909 83.0997 132.985 83.5562 132.75 83.8883C132.611 84.0958 132.383 84.1996 132.155 84.1996Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.909 87.3005C129.806 87.3005 129.709 87.2798 129.626 87.2452C129.536 87.2106 129.46 87.1553 129.391 87.0931C129.322 87.0171 129.267 86.941 129.232 86.8512C129.197 86.7613 129.184 86.6714 129.184 86.5747C129.184 86.4779 129.197 86.3811 129.232 86.2982C129.267 86.2014 129.329 86.1254 129.391 86.0562C129.46 85.9871 129.536 85.9387 129.626 85.9042C129.896 85.7866 130.22 85.8558 130.421 86.0562C130.49 86.1254 130.545 86.2014 130.58 86.2982C130.614 86.388 130.628 86.4779 130.628 86.5747C130.628 86.6714 130.614 86.7682 130.58 86.8512C130.545 86.941 130.49 87.0171 130.421 87.0931C130.29 87.2245 130.103 87.3005 129.909 87.3005Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2008_28844",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.3321 61.7697) scale(62.6748 62.6104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3579,
    stopColor: "#5F879F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7715,
    stopColor: "#527D97",
    stopOpacity: 0.1779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#497692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2008_28844",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.938 93.156) scale(62.2058 62.1418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3579,
    stopColor: "#5F879F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7715,
    stopColor: "#527D97",
    stopOpacity: 0.1779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#497692",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumHouse);
export default __webpack_public_path__ + "static/media/medium-house.862c74c862f2cb0cb3822e98f00546e9.svg";
export { ForwardRef as ReactComponent };